<template lang="pug">
.cadastro-alert-info
  img.cadastro-alert-info__icon(
    src="@/assets/icons/cadastro/info-circle.svg"
    alt=""
  )
  div
    p.cadastro-alert-info__title {{ titulo }}
    p.cadastro-alert-info__text {{ descricao }}
</template>

<script>
export default {
  name: 'CadastroAlertInfo',
  props: {
    titulo: {
      type: String,
      required: true
    },
    descricao: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-alert-info {
  align-items: flex-start;
  background-color: #e7f2fa;
  border: 1px solid rgba(0, 132, 209, 0.3);
  border-radius: 8px;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
}

.cadastro-alert-info__icon {
  flex-shrink: 0;
  height: 20px;
  margin-top: 2px;
  width: 20px;
}

.cadastro-alert-info__title {
  color: #0084d1;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.375;
  margin: 0 0 4px;
}

.cadastro-alert-info__text {
  color: rgba(0, 132, 209, 0.9);
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.625;
  margin: 0;
}
</style>
